/* Wie ems mag lezen.
 *
 * De echte grens is RLS: de policies intern_leest_* op ems.locatie, asset,
 * meting en ingest_run eisen has_role admin, super_admin of crm_user (ADR 0008:
 * "RLS is de enige echte grens, niet de UI"). leesEms.ts stelt dezelfde vraag om
 * nul rijen te duiden: weigering of werkelijk afwezig.
 *
 * Sinds F9.12 staat het EMS binnen de CRM-layout, onder de ProtectedRoute van
 * /crm met dezelfde drie rollen. Het eigen voorportaal van de schermvullende
 * route (EmsToegang) is daarmee weg: een gebruiker met een andere rol komt de
 * CRM-layout niet in, precies zoals bij elke andere /crm-pagina.
 *
 * Staat hier en niet in leesEms.ts, zodat een route-fragment dat altijd geladen
 * wordt de datalaag niet meetrekt. */
export const CRM_ROLLEN = ['admin', 'super_admin', 'crm_user'] as const;
